import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-color-palette',
	templateUrl: './color-palette.component.html',
	styleUrls: ['./color-palette.component.scss']
})
export class ColorPaletteComponent implements OnInit {

	webSafeVals: Array<string> = ['00', '33', '66', '99', 'CC', 'FF'];
	webSafeGreys: Array<string> = [];
	webSafePrimSec: Array<string> = [];
	webSafeRange: Array<string> = [];
	constructor() { }

	ngOnInit() {
		const length = this.webSafeVals.length;
		for (let i = 1, l = length; i < l; i++) {
			this.webSafeGreys.push(this.MakeColor(i, i, i));
		}
		this.webSafePrimSec.push(this.MakeColor(5, 0, 0));
		this.webSafePrimSec.push(this.MakeColor(0, 5, 0));
		this.webSafePrimSec.push(this.MakeColor(0, 0, 5));
		this.webSafePrimSec.push(this.MakeColor(5, 5, 0));
		this.webSafePrimSec.push(this.MakeColor(0, 5, 5));
		this.webSafePrimSec.push(this.MakeColor(5, 0, 5));


		for (let r = 1, rl = length; r < rl; r++) {

		}

	}

	MakeColor(redI: number, greenI: number, blueI: number) {
		return '#' + this.webSafeVals[redI] + this.webSafeVals[greenI] + this.webSafeVals[blueI];
	}

}
